const contactData = {
  phoneDisplay: "+91 99514 02409",
  phoneHref: "tel:+919951402409",
  whatsappHref: "https://wa.me/919951402409",
  email: "metrocrafts.interiors@gmail.com",
  emailHref: "mailto:metrocrafts.interiors@gmail.com",
  websiteDisplay: "www.metrocrafts.in",
  websiteHref: "https://www.metrocrafts.in",
  instagramHandle: "metro_crafts",
  instagramHref: "https://www.instagram.com/metro_crafts/",
  addressLines: ["#8-3-166/D/3, Erragadda,", "Hyderabad, Telangana 500018."],
  addressSingleLine: "#8-3-166/D/3, Erragadda, Hyderabad, Telangana 500018.",
  mapEmbedHref:
    "https://www.google.com/maps?q=8-3-166%2FD%2F3%2C+Erragadda%2C+Hyderabad%2C+Telangana+500018&z=16&output=embed",
};

export default contactData;
